export const mainConstants = {
  MAIN_REQUEST: 'MAIN_REQUEST',
  MAIN_SUCCESS: 'MAIN_SUCCESS',
  MAIN_FAILURE: 'MAIN_FAILURE',

  MAIN_AGG_REQUEST: 'MAIN_AGG_REQUEST',
  MAIN_AGG_SUCCESS: 'MAIN_AGG_SUCCESS',
  MAIN_AGG_FAILURE: 'MAIN_AGG_FAILURE',
};
